import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps;

function MinimizeIcon({ ...props }: Props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M20 10L14 10M14 10L14 4M14 10L21 3M4 14L10 14M10 14L10 20M10 14L3 21" stroke="#101828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export default MinimizeIcon;
